<template>
  <div class="activate_esim">
    <header-component :is-soon="true" :backRoute="false" img-left="/trocachip/img/default_white.png"
      img-right="/trocachip/img/access-white.svg" class="header-component" />

    <section class="activation_esim_section">
      <div class="activate_icon-success">
        <img src="../assets/images/ic-check.svg" v-if="!ac" />
        <img src="../assets/images/ic-check-ac.svg" v-if="ac" />
      </div>

      <h2 class="activate_title" :class="{ 'ac-color-yellow': ac }" v-html="activatePageMessages.title"></h2>
      <p class="activate_info" v-html="activatePageMessages.info"></p>
      <p class="activate_subinfo" v-html="activatePageMessages.subinfo"></p>
      <span id="protocol" class="activate_protocol">
        {{ activatePageMessages.protocolLabel }} {{ protocol }}
      </span>
    </section>

    <section class="layoutToogle">
      <div class="layout">
        <div class="tab-container">
          <input name="nav" type="radio" class="nav home-radio" id="manual" :checked="selectedTab === 'manual'"
            @change="handleTabChange('manual')" />

          <label class="nav" for="manual">
            <span> Instalação Manual </span>
          </label>
        </div>

        <div class="tab-container">
          <input name="nav" type="radio" class="about-radio" id="qrcode" :checked="selectedTab === 'qrcode'"
            @change="handleTabChange('qrcode')" />

          <label class="nav" for="qrcode">
            <span> Via QR Code </span>
          </label>
        </div>
      </div>
    </section>
    <section class="activation_esim_section">
      <img src="../assets/images/step1.svg" />
      <p class="activate_info">
        Conecte-se a um ponto de WiFi com internet antes de iniciar a instalação
        do seu TIM eSIM.
      </p>
      <hr class="section_separator_line" />
    </section>

    <section class="activation_esim_section">
      <img src="../assets/images/step2.svg" />

      <p class="activate_info">
        {{
          selectedTab === "manual"
            ? "Selecione o sistema do seu aparelho e copie o código de ativação para configurar com a rede wifi ativa"
            : "Você pode escanear o QR-code no dispositivo que deseja instalar o TIM eSIM."
        }}
      </p>
      <section class="device_selection_container" v-if="selectedTab === 'manual'">
        <div class="selection_container">
          <div class="selection_input" @click="toggleSystemSelectionOpened">
            <span v-html="systemSelected
                ? systemSelected
                : 'Selecione o sistema do seu aparelho'
              " />
          </div>
          <div class="selection_options_container" :class="{ opened_options: systemSelectionOpened }">
            <label id="device_mark" v-for="(item, index) in systemsListToActive" :key="index" v-html="item"
              :value="item" @click="() => selectSystem(item)" />
          </div>
        </div>
      </section>

      <vue-qrcode :margin="2" :value="urlEsim" class="esim_qr_code" v-if="selectedTab === 'qrcode'" />

      <hr class="section_separator_line" />
    </section>

    <section class="activation_esim_section">
      <img src="../assets/images/step3.svg" />
      <p class="activate_info">
        {{
          selectedTab === "manual"
            ? "Ao iniciar a instalação do seu TIM eSIM, informe o código de ativação abaixo. Não desligue sua rede WiFidurante o processo."
        : "Após concluir a instalação, basta aguardar. Sua linha será ativada em até 6 horas."
        }}
      </p>
      <p class="activate_info" v-if="selectedTab === 'manual'">
        Copie este código de ativação:
      </p>
      <section class="esim_url_section" v-if="
        systemSelected == systemsListToActive.iosSystem &&
        selectedTab === 'manual'
      ">
        <div class="esim_url_container">
          <span class="esim_url" v-html="correctValue(2)"></span>
          <button class="copy_button" v-clipboard:copy="correctValue(2)" v-clipboard:success="onCopy"
            v-clipboard:error="onError">
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>
      </section>

      <section class="esim_url_section" v-if="
        (systemSelected == systemsListToActive.samsungSystem ||
          systemSelected == systemsListToActive.motorolaSystem) &&
        selectedTab === 'manual'
      ">
        <div class="esim_url_container">
          <span class="esim_url" v-html="urlEsim"></span>
          <button class="copy_button" v-clipboard:copy="urlEsim" v-clipboard:success="onCopy"
            v-clipboard:error="onError">
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>
      </section>
      <p class="activate_info" v-if="
        systemSelected == systemsListToActive.iosSystem &&
        selectedTab === 'manual'
      ">
        Endereço SM-DP+
      </p>
      <section class="esim_url_section" v-if="
        systemSelected == systemsListToActive.iosSystem &&
        selectedTab === 'manual'
      ">
        <div class="esim_url_container">
          <span class="esim_url" v-html="correctValue(1)"></span>
          <button class="copy_button" v-clipboard:copy="correctValue(1)" v-clipboard:success="onCopy"
            v-clipboard:error="onError">
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>
      </section>

      <hr class="section_separator_line" />
    </section>

    <section class="activation_esim_section" v-if="selectedTab === 'manual'">
      <img src="../assets/images/step4.svg" />
      <p class="activate_info">
        Após concluir a instalação do TIM eSIM no seu dispositivo, basta
        aguardar. Sua linha será ativada em até 6 horas.
      </p>
      <hr class="section_separator_line" />
    </section>

    <button class="instalation_instructions_button" @click="goToInstallationGuide">
      {{ activatePageMessages.buttonText }}
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VueQrcode from "vue-qrcode";
import HeaderComponent from "../components/HeaderComponent.vue";
import trackEvent from "../services/trackEvent";

export default {
  name: "ActivateEsim",
  components: {
    HeaderComponent,
    VueQrcode,
  },
  data() {
    return {
      systemSelected: "Samsung Android 10.0 ou superior",
      systemSelectionOpened: false,
      systemsListToActive: "",
      selectedTab: "manual",
    };
  },
  created() {
    this.sendTracker("troca esim", 7, 3);
    this.systemsListToActive = this.systemsToActive;
    this.sendCustomDimension('PROTOCOL_TC', this.protocol);
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      activatePageMessages: (state) => state.config.activateEsimPageMessages,
      protocol: (state) => state.protocol,
      urlEsim: (state) => state.urlEsim,
      customer: (state) => state.customer,
      systemsToActive: (state) => state.config.systemsToActive,
      iccid: (state) => state.iccidEsim,
    }),
  },
  methods: {
    async sendCustomDimension(dimension, value) {
      // Convert value to string if it's not already
      const strValue = String(value);

      // Replace spaces, asterisks, and parentheses
      const sanitizedValue = strValue
        .replace(/\s/g, '_')    // Replace spaces with underscores
        .replace(/\*/g, '_')     // Remove asterisks
        .replace(/[()]/g, '_');  // Remove parentheses - no need to escape inside []

      const command = `decibelInsight("sendCustomDimension", "${dimension}", "${sanitizedValue}");`;
console.log(command)
      window.eval(command);
    },
    handleTabChange(tab) {
      this.selectedTab = tab;
    },
    onCopy() {
      this.sendTracker("copiar codigo ativacao");
      console.log("Código copiado");
    },
    onError() {
      console.log("Erro ao copiar código");
    },
    goToInstallationGuide() {
      this.sendTracker("como instalar");
      this.$router.push({ name: "installation-guide" });
    },
    sendTracker(eventLabel, eventCategory = 6, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": eventCategory,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.isExOi() ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    isExOi() {
      if (this.config['init_flow'] === undefined) {
        this.alertError = true;
      }

      return JSON.parse(this.customer.isExOiCustomer);
    },
    selectSystem(value) {
      this.systemSelected = value;
      this.systemSelectionOpened = false;
    },
    toggleSystemSelectionOpened() {
      this.systemSelectionOpened = !this.systemSelectionOpened;
    },
    correctInfo(field) {
      if (this.systemSelected == this.systemsToActive.iosSystem && field == 1) {
        return "Endereço SM-DP+";
      } else if (
        this.systemSelected == this.systemsToActive.iosSystem &&
        field == 2
      ) {
        return "Código de ativação";
      } else return "Código de ativação";
    },
    correctValue(value) {
      const str = this.urlEsim;
      const urlEsim = str.split("$");
      return urlEsim[value];
    },
  },
};
</script>

<style lang="scss" scoped>
.activate_esim {
  width: 100%;
  height: 100vh;
  display: block;
  position: fixed;
  background: #003091;
  overflow-y: auto;
  z-index: -1;

  >.activation_esim_section {
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;

    >.device_selection_container {
      margin-top: 2.125rem;
      display: flex;
      flex-direction: column;
      width: 85vw;

      >.selection_container {
        position: relative;

        >.selection_input {
          width: 100%;
          height: 52px;
          padding: 0px 24px;
          border-radius: 26px;
          color: #000;
          margin-bottom: 1.5rem;
          font-family: "timsans_regular";
          font-size: 1rem;
          -webkit-appearance: none;
          -moz-appearance: none;
          overflow: auto;
          border: 1px solid #b3b3b3;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          cursor: pointer;
          background-color: #ffffff;
        }

        >.selection_options_container {
          display: none;
        }

        >.selection_options_container.opened_options {
          position: absolute;
          display: flex;
          width: 100%;
          max-height: 200px;
          overflow-y: scroll;
          overflow-x: hidden;
          flex-direction: column;
          background: #fff;
          border-radius: 16px;
          box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.15);
          z-index: 10;

          >label {
            width: 100%;
            padding: 24px 0 0 24px;
            font-family: "timsans_regular";
            font-size: 0.875rem;
            color: #9c9c9c;
            line-height: 21px;
            cursor: pointer;
          }

          >label:last-child {
            padding-bottom: 24px;
          }

          >label:hover {
            background-color: #e7e7e7;
          }
        }

        >.selection_input::-ms-expand {
          display: none;
        }

        >.selection_input::after {
          content: "<";
          font: 20px "Consolas", monospace;
          color: #9c9c9c;
          -webkit-transform: rotate(180deg) scaleY(1.2);
          -moz-transform: rotate(270deg) scaleY(1.2);
          -ms-transform: rotate(270deg) scaleY(1.2);
          transform: rotate(270deg) scaleY(1.2);
          right: 40px;
          position: absolute;
          pointer-events: none;
        }
      }
    }

    >.activate_icon-success {
      width: 61px;
      height: 61px;
      margin: 63px auto 0 auto;
      position: relative;
      display: block;
    }

    >.activate_title {
      width: 292px;
      height: auto;
      display: block;
      position: relative;
      font-family: "timsans_regular";
      margin: 40px auto 0 auto;
      font-size: 1.688em;
      font-weight: 300;
      line-height: 1.11;
      text-align: center;
      color: #ffffff;
    }

    >.activate_info {
      width: 85vw;
      height: auto;
      display: block;
      position: relative;
      margin: 16px auto 0 auto;
      font-family: "timsans_regular";
      font-size: 14px;
      line-height: 1.33;
      letter-spacing: -0.3px;
      text-align: center;
      color: #ffffff;
    }

    >.activate_info_values {
      width: 85vw;
      height: auto;
      display: block;
      position: relative;
      margin: 16px auto 0 auto;
      font-family: "timsans_regular";
      font-size: 1em;
      line-height: 1.33;
      letter-spacing: -0.3px;
      color: #ffffff;
    }

    >.activate_subinfo {
      width: 85vw;
      height: auto;
      display: block;
      position: relative;
      margin: 16px auto 0 auto;
      font-family: "timsans_regular";
      font-size: 0.75em;
      line-height: 1.33;
      letter-spacing: -0.3px;
      text-align: center;
      color: #ffffff;
    }

    >.activate_protocol {
      width: 147px;
      height: auto;
      display: block;
      position: relative;
      margin: 16px auto 0 auto;
      font-family: "timsans_regular";
      font-size: 0.75em;
      line-height: 2;
      text-align: center;
      color: #ffffff;
    }

    >.section_separator_line {
      width: 85vw;
      height: 1px;
      background-color: #d9d9d9;
      margin: 26px 0 32px 0;
      border: none;
      opacity: 0.5;
    }

    >.esim_qr_code {
      border-radius: 8px;
      margin-top: 22px;
    }

    >.esim_url_section {
      margin-top: 24px;

      border: 1px dashed #bababa;
      border-radius: 12px;
      background-color: #fff;
      width: 85%;
      height: 56px;

      >.esim_url_container {
        padding-left: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 8px;

        >.esim_url {
          white-space: nowrap;
          word-wrap: break-word;
          text-overflow: ellipsis;
          overflow: hidden;
          font-family: "timsans_regular";
          color: #000;
          padding-right: 5px;
        }

        >.copy_button {
          height: 50px;
          background: transparent;
          cursor: pointer;
          padding: 0px 14px;
          border-left: 1px dashed #bababa;
          border-right: none;
        }
      }
    }
  }

  .layoutToogle {
    display: flex;
    height: 80px;
    padding: 0px 24px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    border-bottom: 1px solid #3152ef;
    margin: 32px 0 40px 0;

    .layout {
      font-family: "timsans_regular";
      padding: 0 0.5rem;
      width: 100%;
      align-items: center;
      display: flex;
      padding-top: 28px;
      gap: 24px;
    }
  }

  .tab-container {
    flex: 1;
    text-align: center;
    color: #e5e5e5;
  }

  input[type="radio"] {
    display: none;
  }

  input[type="radio"]:checked+label {
    color: #e5e5e5;
    margin-bottom: 0;
    border-bottom: 4px solid #e5e5e5;
  }

  label.nav {
    box-sizing: border-box;
    padding: 1.8rem 0;
    cursor: pointer;
  }

  >.instalation_instructions_button {
    width: 85vw;
    height: 52px;
    border: 1px solid #fff;
    border-radius: 26px;
    color: #fff;
    background-color: transparent;
    margin: 26px;
    font-family: "timsans_regular";
  }
}
</style>
